
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBundleDesc = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.154 9h27.692C36.483 9 37 9.473 37 10.056v3.166c0 .583-.517 1.056-1.154 1.056H8.154c-.637 0-1.154-.473-1.154-1.056v-3.166C7 9.473 7.517 9 8.154 9zM35 14.278v19.086c0 .903-.53 1.636-1.182 1.636H10.182C9.529 35 9 34.267 9 33.364V14.278h26z",
  stroke: "#000",
  strokeWidth: 2.75
}), /*#__PURE__*/React.createElement("path", {
  d: "m22.254 28.17 2.91 1.758c.372.224.834-.11.724-.524l-.841-3.152a.468.468 0 0 1 .164-.489l2.609-2.07c.343-.272.166-.814-.275-.842l-3.407-.21a.484.484 0 0 1-.418-.295l-1.271-3.05A.48.48 0 0 0 22 19a.48.48 0 0 0-.449.295l-1.27 3.051a.484.484 0 0 1-.419.295l-3.407.21c-.44.028-.618.57-.275.842l2.61 2.07c.148.12.211.31.163.489l-.78 2.923c-.132.497.422.898.868.629l2.705-1.634a.494.494 0 0 1 .508 0z",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2
}))));

      const __svgRaw = "<svg width=\"44\" height=\"44\" viewBox=\"0 0 44 44\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n        <path d=\"M8.154 9h27.692C36.483 9 37 9.473 37 10.056v3.166c0 .583-.517 1.056-1.154 1.056H8.154c-.637 0-1.154-.473-1.154-1.056v-3.166C7 9.473 7.517 9 8.154 9zM35 14.278v19.086c0 .903-.53 1.636-1.182 1.636H10.182C9.529 35 9 34.267 9 33.364V14.278h26z\" stroke=\"#000\" stroke-width=\"2.75\"/>\r\n        <path d=\"m22.254 28.17 2.91 1.758c.372.224.834-.11.724-.524l-.841-3.152a.468.468 0 0 1 .164-.489l2.609-2.07c.343-.272.166-.814-.275-.842l-3.407-.21a.484.484 0 0 1-.418-.295l-1.271-3.05A.48.48 0 0 0 22 19a.48.48 0 0 0-.449.295l-1.27 3.051a.484.484 0 0 1-.419.295l-3.407.21c-.44.028-.618.57-.275.842l2.61 2.07c.148.12.211.31.163.489l-.78 2.923c-.132.497.422.898.868.629l2.705-1.634a.494.494 0 0 1 .508 0z\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/bundle-desc.e02eb71c1f8fb3d266841fd6a152cfcf.svg"),
        {
          React: SvgBundleDesc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      